import { render, staticRenderFns } from "./GroupInterests.vue?vue&type=template&id=daa6b91e&scoped=true"
import script from "./GroupInterests.vue?vue&type=script&lang=js"
export * from "./GroupInterests.vue?vue&type=script&lang=js"
import style0 from "./GroupInterests.vue?vue&type=style&index=0&id=daa6b91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa6b91e",
  null
  
)

export default component.exports